import './cookie-message.scss';
import { grantConsent } from '../../lib/cookie-consent';

class CookieMessage {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-cookiemessage',
            activeAttr: 'data-cookiemessage-active',
            buttonValue: 'button'
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;
        this.$enableButton = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.buttonValue}"]`);

        this.$target = document.querySelector('[data-cookiemessage]');

        // Options
        this.cookieId = this.$root.getAttribute(this.settings.initAttr);
        this.cookieIsEnabled = false;
    }

    initialize () {
        const consentInitializedCallbacks = () => {
            this.cookieIsEnabled = window.enabledCookies.includes(this.cookieId);
            this.toggleState(!this.cookieIsEnabled);
            this.setEvents();
        };

        if (window.cookieConsentInitialized) {
            consentInitializedCallbacks();
        } else {
            window.addEventListener('cookieConsentInitialized', consentInitializedCallbacks);
        }
    }

    toggleState (active) {
        if (active) {
            this.$root.setAttribute(this.settings.activeAttr, true);
            this.cookieIsEnabled = false;
        } else {
            this.$root.setAttribute(this.settings.activeAttr, false);
            this.cookieIsEnabled = true;
        }
    }

    setEvents () {
        if (this.$enableButton) {
            this.$enableButton.addEventListener('click', () => {
                if (!window.enabledCookies.includes(this.cookieId)) {
                    grantConsent(this.cookieId);
                }
            });
        }

        const handleConsentChange = () => {
            this.toggleState(!window.enabledCookies.includes(this.cookieId));
        };

        window.addEventListener('cookieConsentChanged', handleConsentChange);
    }
}

export { CookieMessage };
